import { useCallback } from 'react'
import { useQuery } from '@apollo/client'
import { Query_Root } from '../../graphql/indexer-graphql-types'
import { DROP_TIME_QUERY } from '../../graphql/graphql-queries'
import { SetScheduleTime } from '../../data/SetScheduleTime'
import {
  draftScheduleTimeAtom,
  rwIsTranscodingFinished,
  rwUploadStepAtom,
  CreateSteps,
  isUserVerifiedAtom,
} from '../../atoms/Creation'
import { useAtom } from 'jotai'
import log from '../../events/log'
import * as CreationEvents from '../../events/creation_events'

export const useScheduleTime = (
  mint: string | undefined
): {
  scheduleTime: Date | undefined
} => {
  const dropTimeData = mint
    ? // eslint-disable-next-line react-hooks/rules-of-hooks
      useQuery<Query_Root>(DROP_TIME_QUERY, {
        variables: { mint },
      })?.data
    : undefined

  const dropTime = dropTimeData?.mint[0]?.dropTime?.dropTime
  const scheduleTime = dropTime ? new Date(dropTime) : undefined
  return { scheduleTime }
}

export const useDraftScheduleTime = (
  mint: string | undefined
): {
  scheduleTime: Date | undefined
  setScheduleTime: (date: Date) => Promise<void>
} => {
  const [scheduleTime, setDraftScheduleTimeInAtom] = useAtom(draftScheduleTimeAtom)
  const [, setUploadStep] = useAtom(rwUploadStepAtom)
  const [isTranscodingFinished] = useAtom(rwIsTranscodingFinished)
  const [isVerified] = useAtom(isUserVerifiedAtom)

  /*
    // This code will be needed when we get rid of atom
    const dropTimeData = useQuery<Query_Root>(DRAFT_DROP_TIME_QUERY, {
      variables: { mint },
    })?.data

    const dropTime = dropTimeData?.dropTimes[0]?.dropTime
    const scheduleTime = dropTime ? new Date(dropTime) : undefined
  */

  const setScheduleTime = useCallback(
    async (time: Date) => {
      if (!mint) {
        return
      }

      log(
        new CreationEvents.SubmittedDropTimeEvent((time.getTime() - new Date().getTime()) / 3600000)
      )

      await SetScheduleTime(mint, time)

      // update atom to store draftScheduleTime
      setDraftScheduleTimeInAtom(time)

      if (!isVerified) {
        setUploadStep(CreateSteps.VERIFICATION)
      } else {
        if (isTranscodingFinished) {
          setUploadStep(CreateSteps.MINT)
        } else {
          setUploadStep(CreateSteps.PROCESSING)
        }
      }
    },
    [isTranscodingFinished, isVerified, mint, setDraftScheduleTimeInAtom, setUploadStep]
  )

  return { scheduleTime, setScheduleTime }
}
